import { Helmet } from "react-helmet-async";
import { defaultSiteDescription, defaultSiteTitle } from "@/lib/seoConfig";

/**
 * App-wide defaults only. Per-route meta is set with SeoHead; do not set a global
 * canonical here so each route owns one canonical URL.
 */
export default function SiteMetadata() {
  return (
    <Helmet>
      <html lang="en" />
      <meta name="description" content={defaultSiteDescription} />
      <meta property="og:site_name" content="NovelNet" />
      <title>{defaultSiteTitle}</title>
    </Helmet>
  );
}
